exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.css
// module id = ../../../../../src/app/auth/reset-password/reset-password-invalid/reset-password-invalid.component.css
// module chunks = main